<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          BRAND
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9>
            {{ id ? 'Edit Brand' : 'Create New Brand' }}
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon @click="clear" title="refresh">refresh</v-icon>
          </v-flex>
        </v-card-title>
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="save" class="pa-5">
            <v-layout row wrap>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="Name"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">Name</label>
                  <v-text-field
                    id="name"
                    single-line
                    outlined
                    placeholder="Name"
                    dense
                    v-model="items.name"
                    required
                    class="px-5"
                    :error-messages="errors"
                    :success="valid"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="Entity"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">Entity</label>
                  <v-autocomplete
                    id="entity"
                    single-line
                    outlined
                    placeholder="Select Entity"
                    v-model="items.entity_id"
                    required
                    dense
                    class="px-5"
                    :items="itemsEntity"
                    item-value="id"
                    item-text="name"
                    :error-messages="errors"
                    :success="valid"
                  ></v-autocomplete>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="House"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">House</label>
                  <v-autocomplete
                    id="house"
                    single-line
                    outlined
                    placeholder="Select House"
                    v-model="items.house_id"
                    required
                    dense
                    class="px-5"
                    :items="itemsHouse"
                    item-value="id"
                    item-text="name"
                    :error-messages="errors"
                    :success="valid"
                  ></v-autocomplete>
                </ValidationProvider>
              </v-flex>
            </v-layout>
            <v-card-actions class="text-right">
              <v-spacer></v-spacer>
              <v-flex xs2 right class="mr-4">
                <v-btn
                  id="btn-cancel"
                  dark
                  rounded
                  color="red"
                  block
                  :to="{ name: 'brand' }"
                >
                  Cancel
                </v-btn>
              </v-flex>
              <v-flex xs2 right>
                <v-btn
                  id="btn-save"
                  dark
                  rounded
                  color="blue darken-3"
                  block
                  @click="save()"
                >
                  Save
                </v-btn>
              </v-flex>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../../components/progress_dialog';
import 'sweetalert2/src/sweetalert2.scss';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  components: { 'progress-dialog': ProgressDialog },
  props: ['id'],
  data() {
    return {
      items: {
        name: '',
        entity_id: null,
        house_id: null
      },
      loading: true,
      progressDialogLoading: true,
      search: '',
      itemsEntity: [],
      itemsHouse: [],
      breadcrumbs: [
        {
          text: 'Master Data',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Brand List',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: this.id ? 'Edit Brand' : 'Create New Brand',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ]
    };
  },
  mounted() {
    this.getEntity();
    this.getHouse();
    if (this.id) {
      this.getDetail();
    } else {
      setTimeout(() => {
        this.progressDialogLoading = false;
        this.loading = false;
      }, 800);
    }
  },
  methods: {
    getEntity() {
      const limit = 100;
      this.$store
        .dispatch('entity/getAll', { limit })
        .then(data => {
          if (data.code === 200) {
            this.itemsEntity = data.data.result;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getHouse() {
      const limit = 100;
      this.$store
        .dispatch('house/getAll', { limit })
        .then(data => {
          if (data.code === 200) {
            this.itemsHouse = data.data.result;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getDetail() {
      this.progressDialogLoading = true;
      this.loading = true;
      this.$store
        .dispatch('brand/detail', this.id)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.items = data.data.result;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    async clear() {
      this.items = {
        name: '',
        entity_id: null,
        house_id: null
      };
      requestAnimationFrame(() => {
        this.$refs.obs.reset();
      });
    },
    save() {
      const validated = this.$refs.obs.validate();
      if (validated) {
        this.progressDialogLoading = true;
        this.loading = true;
        if (this.id) {
          this.$store
            .dispatch('brand/update', { id: this.id, params: this.items })
            .then(data => {
              this.progressDialogLoading = false;
              this.loading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.clear();
                this.$router.push({
                  name: 'brand'
                });
              } else {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
              this.progressDialogLoading = false;
              this.loading = false;
            });
        } else {
          this.$store
            .dispatch('brand/create', this.items)
            .then(data => {
              this.progressDialogLoading = false;
              this.loading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.clear();
                this.$router.push({
                  name: 'brand'
                });
              } else {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
              this.progressDialogLoading = false;
              this.loading = false;
            });
        }
      }
    }
  }
};
</script>
